export default __webpack_public_path__ + "static/0113-fe933ec4d1c9ca577eecb4f976e14959.png";